module.exports = __webpack_public_path__ + "img/Logo colorido 1.acdd4d37.png";